<script src="../../common/excel/Export2Excel.js"></script>
<template>
    <div class="bill-deatils">
        <div class="bill-d-footer" v-if="isPrint">
            <div class="footer-in">
                <div class="dy" @click="printBtn"><i class="iconfont icon-print"></i>打 &nbsp;印</div>
                <div class="dc" @click="export2Excel"><i class="iconfont icon-tuichu"></i>导出账单</div>
            </div>
        </div>
        <div id="subOutputRank-print">
            <div class="loading" style="text-align: center">
                <Loading :isLoading="isLoading"></Loading>
            </div>
            <div v-if="!isLoading" class="bill-deatils" style="padding-top: 0">
                <div>
                    <div class="bill-d-head">
                        <div class="left">
                            <span>客户账单</span>
                            <span class="E">CN CUSTOMER BILLING</span>
                        </div>
                        <div class="right">
                            <img src="../../assets/img/Logo.png" height="36" width="161"/>
                        </div>
                    </div>
                    <div class="bill-d-main">
                        <div class="main-info">
                            <h5>客户信息</h5>
                            <div class="left">
                                <div class="item">
                                    <label>账单编号：</label>
                                    <span>{{BillInfo.NO}}</span>
                                </div>
                                <div class="item">
                                    <label>客户名称：</label>
                                    <span>{{BillInfo.CustomerName}}</span>
                                </div>
                                <div class="item">
                                    <label>地址：</label>
                                    <span>{{BillInfo.Address}}</span>
                                </div>
                                <div class="item">
                                    <label>联络人：</label>
                                    <span>{{BillInfo.Contactor}}</span>
                                </div>
                                <div class="item">
                                    <label>电话：</label>
                                    <span>{{BillInfo.Phone}}</span>
                                </div>
                                <div class="item">
                                    <label>传真：</label>
                                    <span>{{BillInfo.Fax}}</span>
                                </div>

                            </div>
                            <!--<div class="right">-->
                                <!--<div class="item">-->
                                    <!--<label>结算周期：</label>-->
                                    <!--<span>自定义时间段（至1949-10-01到1949-10-01)</span>-->
                                <!--</div>-->
                                <!--<div class="item">-->
                                    <!--<label>发送者：</label>-->
                                    <!--<span>（云境）</span>-->
                                <!--</div>-->
                                <!--<div class="item">-->
                                    <!--<label>电话：</label>-->
                                    <!--<span></span>-->
                                <!--</div>-->
                                <!--<div class="item">-->
                                    <!--<label>传真：</label>-->
                                    <!--<span></span>-->
                                <!--</div>-->
                                <!--<div class="item">-->
                                    <!--<label>收件人：</label>-->
                                    <!--<span></span>-->
                                <!--</div>-->
                            <!--</div>-->
                        </div>
                        <div class="main-table">
                            <h5>账单明细</h5>
                            <table id="table">
                                <thead>
                                <tr>
                                    <th style="min-width: 50px">订单号</th>
                                    <th style="min-width: 75px">入住日期</th>
                                    <th style="min-width: 75px">离店日期</th>
                                    <th style="min-width: 40px">酒店</th>
                                    <th style="min-width: 50px">入住人</th>
                                    <th style="min-width: 35px">房型</th>
                                    <th style="min-width: 35px">间数</th>
                                    <th style="min-width: 35px">晚数</th>
                                    <th style="min-width: 35px">币种</th>
                                    <th style="min-width: 60px">应收房款</th>
                                    <th style="min-width: 60px">已收房款</th>
                                    <th style="min-width: 60px">尚欠房款</th>
                                    <th style="min-width: 60px">预定日期</th>
                                    <th style="min-width: 60px">客户单号</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-for="item in BillInfo.Orders">
                                    <td>{{item.OrderNO}}</td>
                                    <td>{{item.CheckIn|dateToYMDline}}</td>
                                    <td>{{item.CheckOut|dateToYMDline}}</td>
                                    <td><span class="ellips" style="width: 120px" :title="item.HotelName">{{item.HotelName}}</span></td>
                                    <td>{{item.Guest}}</td>
                                    <td><span class="ellips" style="width: 120px" :title="item.RoomName">{{item.RoomName}}</span></td>
                                    <td>{{item.RoomCount}}</td>
                                    <td>{{item.NightCount}}</td>
                                    <td>{{item.Currency}}</td>
                                    <td>{{item.SellPrice.toFixed(2)}}</td>
                                    <td>{{item.ReceivedAmount.toFixed(2)}}</td>
                                    <td>{{(item.SellPrice - item.ReceivedAmount).toFixed(2)}}</td>
                                    <td>{{item.CreatedOn|dateToYMDline}}</td>
                                    <td>{{item.ThirdOrderNO}}</td>
                                </tr>
                                <tr>
                                    <td>小计</td>
                                    <td colspan="14">总共{{BillInfo.NRC}}间夜，应收：{{parseInt(BillInfo.Receivable).toFixed(2)}}{{BillInfo.Currency}}，已收：{{parseInt(BillInfo.Received).toFixed(2)}}{{BillInfo.Currency}}，尚欠金额：{{(BillInfo.Receivable - BillInfo.Received).toFixed(2)}}{{BillInfo.Currency}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="main-payment-info">
                            <div class="item">
                                <label>户&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
                                <span>深圳市港捷旅国际旅行社有限公司</span>
                            </div>
                            <div class="item">
                                <label>开户行：</label>
                                <span>中国银行深圳市分行</span>
                            </div>
                            <div class="item">
                                <label>帐&nbsp;&nbsp;&nbsp;&nbsp;号：</label>
                                <span>757557928199</span>
                            </div>
                        </div>
                        <div class="Tips">
                            <div class="item">
                                <label style="font-weight: bold">特别提示：</label>
                                <span>收到账单后，请及时核对，请在15日前付款，如逾期，系统将自动锁单，给您带来不便敬请谅解！</span><br>
                                <span>我司财务的QQ均为“23559”开头的企业QQ，请勿盲目相信其他QQ发的信息!</span><br>
                                <span>感谢您的支持！</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    export default {
        name: "billDetails",
        components:{
          Loading
        },
        data: function () {
            return {
                isLoading:false,
                BillInfo:'',
                isPrint:true,
                idTmr:''
            }
        },
        mounted() {
            this.initData();
            document.title='账单详情---云境';
            var that = this
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }         
            })
        },
        methods: {
            export2Excel() {
                var that = this;
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/excel/Export2Excel'); //这里必须使用绝对路径
                    let tHeader =['订单号','入住日期', '离店日期', '酒店','入住人','房型','间数','晚数','币种','应收房款','已收房款','尚欠房款','预定日期','客户单号'];
                    const filterVal = ['OrderNO','CheckIn','CheckOut', 'HotelName','Guest','RoomName','RoomCount','NightCount','Currency','SellPrice','ReceivedAmount','Arrearage','CreatedOn','ThirdOrderNO']; // 导出的表头字段名
                    const list = that.tableExcelData(that.BillInfo.Orders);
                    const data = that.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, that.BillInfo.NO+'账单');// 导出的表格名称，根据需要自己命名
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            tableExcelData(list){
                var lis = list
                for(let i=0; i<lis.length; i++){
                    lis[i].Arrearage = lis[i].SellPrice - lis[i].ReceivedAmount
                }
                return lis
            },
            printBtn(){
                let subOutputRankPrint = document.getElementById('subOutputRank-print');
                let newContent =subOutputRankPrint.innerHTML;
                let oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                return false;
            },
            initData(){
                var that = this;
                that.isLoading = true
                that.getRequest({
                    url: that.Api.getBill+'?id='+that.$route.params.id,
                    params: ''
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.BillInfo = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }         
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/bill/Details.vue